import { LOCALES } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

export const getLocaleFromPath = (path: string): string | null => {
  const supportedLocales = Object.values(LOCALES).map(toBcp47Locale)
  const localeRegex = new RegExp(`^/(${supportedLocales.join('|')})(?:/|$)`)
  const match = path.match(localeRegex)

  if (!match) return null

  return match[1]
}
